import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const LoyaltyRoutes: Routes = [
  {
    path: "loyalty",
    loadComponent: () =>
      import("./loyalty/loyalty.component").then((m) => m.LoyaltyComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./loyalty-list/loyalty-list.component").then(
            (m) => m.LoyaltyListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./loyalty-form/loyalty-form.component").then(
            (m) => m.LoyaltyFormComponent,
          ),
      },
      {
        path: "view/:loyaltyProgramId",
        loadComponent: () =>
          import("./loyalty-form/loyalty-form.component").then(
            (m) => m.LoyaltyFormComponent,
          ),
      },
      {
        path: "view/:loyaltyProgramId/rule",
        loadComponent: () =>
          import("./exception-rule-form/exception-rule-form.component").then(
            (m) => m.ExceptionRuleFormComponent,
          ),
      },
      {
        path: "view/:loyaltyProgramId/rule/:exceptionRuleId",
        loadComponent: () =>
          import("./exception-rule-form/exception-rule-form.component").then(
            (m) => m.ExceptionRuleFormComponent,
          ),
      },
      {
        path: "view/:loyaltyProgramId/rule/:exceptionRuleId/clone",
        loadComponent: () =>
          import("./exception-rule-form/exception-rule-form.component").then(
            (m) => m.ExceptionRuleFormComponent,
          ),
        data: {
          isCloning: true,
        },
      },
    ],
  },
];
